export const options = [
  { label: 'All notifications, except the ones you unsubscribe from in emails.', value: 1 },
  { label: 'Only notifications related to my account (no promotional emails).', value: 3 },
];
